import { render } from "./SourceIndex.vue?vue&type=template&id=2bd85344"
import script from "./SourceIndex.vue?vue&type=script&lang=js"
export * from "./SourceIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__